import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { Language, languages } from '../languages.model';
import { I18nService } from '../i18n.service';

import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'gnx-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  imports: [MatMenuTrigger, MatMenu, MatMenuItem],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LanguageSelectorComponent implements OnInit {
  private i18n = inject(I18nService);

  public languages: Language[];
  public currentLanguage: Language;

  ngOnInit() {
    this.languages = languages;
    this.currentLanguage = this.i18n.getLanguage();
  }

  setLanguage(language: Language) {
    this.currentLanguage = language;
    this.i18n.setLanguage(language);
  }
}
